export const ROUTES = {
  tabs: 'tabs',
  calendar: 'calendar',
};
